function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#616161",
  d: "M21.6 18.6c0 1.657-1.343 3-3 3H3c-1.657 0-3-1.343-3-3V3c0-1.657 1.343-3 3-3h15.6c1.657 0 3 1.343 3 3v15.6z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M10.7 4C8.116 4 5.86 5.411 4.647 7.5h1.71c.63-.778 1.452-1.394 2.408-1.749-.219.51-.394 1.105-.529 1.749h1.44c.335-1.384.805-2.1 1.024-2.1.22 0 .689.716 1.024 2.1h1.44c-.135-.644-.311-1.239-.53-1.749.957.355 1.78.97 2.41 1.749h1.709C15.54 5.411 13.284 4 10.7 4zM3 8.9l.87 4.2h.916l.594-2.43.594 2.43h.912l.87-4.2H6.701l-.376 2.356L5.767 8.9h-.78l-.56 2.36-.372-2.36H3zm5.322 0l.87 4.2h.916l.595-2.43.593 2.43h.912l.87-4.2h-1.052l-.377 2.356L11.09 8.9h-.78l-.56 2.36-.373-2.36H8.322zm5.323 0l.87 4.2h.915l.595-2.43.594 2.43h.911l.87-4.2h-1.053l-.376 2.356-.559-2.356h-.78l-.56 2.36L14.7 8.9h-1.055zm-8.998 5.6C5.86 16.589 8.116 18 10.7 18s4.84-1.411 6.053-3.5h-1.71c-.63.778-1.452 1.394-2.408 1.749.218-.51.393-1.105.527-1.749h-1.44c-.335 1.384-.804 2.1-1.023 2.1-.22 0-.688-.716-1.023-2.1h-1.44c.135.644.311 1.239.53 1.749-.957-.355-1.78-.97-2.41-1.749H4.647z"
}));

var SvgIconWebsite = function SvgIconWebsite(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconWebsite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-website.e718f6be.svg";
export { ForwardRef as ReactComponent };